import React, { Component } from "react";

class ProductClient extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div id="detalleProductoCliente">
                  <fieldset>
                    <legend>
                      DETALLE DEL PRODUCTO MEDICAMENTO VETERINARIO
                    </legend>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Nombre comercial:</label>
                          <div className="form-control">
                            {this.props.producto.nombre_comercial}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Tipo producto veterinario:</label>
                          <div className="form-control">
                            {this.props.producto.tpv}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>País de origen:</label>
                          <div className="form-control">
                            {this.props.producto.pais}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Caducidad del producto:</label>
                          <div className="form-control">
                            {this.props.producto.caducidad_producto}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Tiempo:</label>
                          <div className="form-control">
                            {this.props.producto.medida_tiempo}
                          </div>
                        </div>
                      </div>
                    </div>

                    {["1", "2", "3"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Forma farmacéutica:</label>
                            <div className="form-control">
                              {this.props.producto.forma_farmaceutica}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : ["5"].includes(
                        this.props.producto.tipo_producto_veterinario_id
                      ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Forma de comercialización:</label>
                            <div className="form-control">
                              {this.props.producto.forma_farmaceutica}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {["1", "3", "4"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Precauciones generales:</label>
                            <div className="form-control">
                              {this.props.producto.precauciones_generales ||
                                "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : ["2", "5"].includes(
                        this.props.producto.tipo_producto_veterinario_id
                      ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Precauciones almacenamiento:</label>
                            <div className="form-control">
                              {this.props.producto
                                .precauciones_almacenamiento || "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {["1", "3", "4", "5"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Indicaciones de uso:</label>
                            <div className="form-control">
                              {this.props.producto.uso}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {["2", "5"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Precauciones de uso:</label>
                            <div className="form-control">
                              {this.props.producto.precauciones_uso}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {["4"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Instrucciones de uso:</label>
                            <div className="form-control">
                              {this.props.producto.instrucciones_uso}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}

                    {["1"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>
                              Válidez para preparación extemporánea:
                            </label>
                            <div className="form-control">
                              {this.props.producto.validez_preparacion || "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}

                    {["2"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Propiedades inmunológicas:</label>
                            <div className="form-control">
                              {this.props.producto.propiedades_inmunologicas ||
                                "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Fabricante:</label>
                          <div className="form-control">
                            {this.props.producto.fabricante || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Titular:</label>
                          <div className="form-control">
                            {this.props.producto.titular || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <br />

                  <fieldset>
                    <legend>DETALLES TIPO DE PRODUCTO</legend>

                    <div className="row">
                      <div className="col-lg-12">
                        {["1", "3"].includes(
                          this.props.producto.tipo_producto_veterinario_id
                        ) ? (
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th width="33.33%" className="text-center">
                                  PRINCIPIO ACTIVO
                                </th>
                                <th width="33.33%" className="text-center">
                                  CONCENTRACIÓN
                                </th>
                                <th width="33.33%" className="text-center">
                                  UNIDAD DE MEDIDA PA
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.producto.principio_activo &&
                              this.props.producto.principio_activo.length >
                                0 ? (
                                this.props.producto.principio_activo.map(
                                  (pa, index) => (
                                    <tr key={index}>
                                      <td className="text-center">
                                        {pa.ingrediente}
                                      </td>
                                      <td className="text-center">
                                        {pa.concentracion}
                                      </td>
                                      <td className="text-center">
                                        {pa.unidad_medida}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No se encontraron datos
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : ["2"].includes(
                            this.props.producto.tipo_producto_veterinario_id
                          ) ? (
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th width="50%" className="text-center">
                                  COMPOSICIÓN BIOLÓGICA
                                </th>
                                <th width="50%" className="text-center">
                                  TÍTULO
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.producto.composicion_biologica &&
                              this.props.producto.composicion_biologica.length >
                                0 ? (
                                this.props.producto.composicion_biologica.map(
                                  (cb, index) => (
                                    <tr key={index}>
                                      <td className="text-center">
                                        {cb.composicion}
                                      </td>
                                      <td className="text-center">
                                        {cb.titulo}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No se encontraron datos
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : null}
                      </div>
                    </div>

                    {["1", "3"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <>
                        <br />
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="33.33%" className="text-center">
                                    EXCIPIENTE
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    CONCENTRACIÓN
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    UNIDAD DE MEDIDA PA
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.excipiente &&
                                this.props.producto.excipiente.length > 0 ? (
                                  this.props.producto.excipiente.map(
                                    (e, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {e.excipiente}
                                        </td>
                                        <td className="text-center">
                                          {e.concentracion}
                                        </td>
                                        <td className="text-center">
                                          {e.unidad_medida}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : ["2"].includes(
                        this.props.producto.tipo_producto_veterinario_id
                      ) ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th width="33.33%" className="text-center">
                                  COMPOSICIÓN QUÍMICA
                                </th>
                                <th width="33.33%" className="text-center">
                                  CONCENTRACIÓN
                                </th>
                                <th width="33.33%" className="text-center">
                                  UNIDAD DE MEDIDA
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.producto.composicion_quimica &&
                              this.props.producto.composicion_quimica.length >
                                0 ? (
                                this.props.producto.composicion_quimica.map(
                                  (cq, index) => (
                                    <tr key={index}>
                                      <td className="text-center">
                                        {cq.composicion}
                                      </td>
                                      <td className="text-center">
                                        {cq.concentracion}
                                      </td>
                                      <td className="text-center">
                                        {cq.unidad_medida}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No se encontraron datos
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : ["4"].includes(
                        this.props.producto.tipo_producto_veterinario_id
                      ) ? (
                      <>
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="50%" className="text-center">
                                    COMPONENTES
                                  </th>
                                  <th width="50%" className="text-center">
                                    CONCENTRACIÓN
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.componente &&
                                this.props.producto.componente.length > 0 ? (
                                  this.props.producto.componente.map(
                                    (c, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {c.componente}
                                        </td>
                                        <td className="text-center">
                                          {c.concentracion}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <br />

                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th className="text-center">
                                    ESPECIES DE INTERÉS DIAGNÓSTICO
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.especieInteres &&
                                this.props.producto.especieInteres.length >
                                  0 ? (
                                  this.props.producto.especieInteres.map(
                                    (ei, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {ei.especie_interes}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <br />

                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="50%" className="text-center">
                                    PRESENTACIONES CANTIDAD
                                  </th>
                                  <th width="50%" className="text-center">
                                    UNIDAD MEDIDA
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.presentacion &&
                                this.props.producto.presentacion.length > 0 ? (
                                  this.props.producto.presentacion.map(
                                    (p, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {p.cantidad}
                                        </td>
                                        <td className="text-center">
                                          {p.unidad_medida}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : ["5"].includes(
                        this.props.producto.tipo_producto_veterinario_id
                      ) ? (
                      <>
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="50%" className="text-center">
                                    ANÁLISIS GARANTIZADO
                                  </th>
                                  <th width="50%" className="text-center">
                                    PORCENTAJE (%)
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.presentacion &&
                                this.props.producto.presentacion.length > 0 ? (
                                  this.props.producto.presentacion.map(
                                    (c, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {c.analisis}
                                        </td>
                                        <td className="text-center">
                                          {c.porcentaje}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <br />

                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th className="text-center">INGREDIENTE</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.principio_activo &&
                                this.props.producto.principio_activo.length >
                                  0 ? (
                                  this.props.producto.principio_activo.map(
                                    (pa, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {pa.ingrediente}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {["1", "2", "5"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <>
                        <br />
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="33.33%" className="text-center">
                                    DOSIS POR ESPECIE Y VÍA DE ADMINISTRACIÓN
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    ESPECIE DESTINO
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    CATEGORÍA
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.dosis &&
                                this.props.producto.dosis.length > 0 ? (
                                  this.props.producto.dosis.map((d, index) => (
                                    <tr key={index}>
                                      <td className="text-center">{d.dosis}</td>
                                      <td className="text-center">
                                        {d.especie}
                                      </td>
                                      <td className="text-center">
                                        {d.categoria || "N/A"}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {["3"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <>
                        <br />
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="33.33%" className="text-center">
                                    MODO DE EMPLEO
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    ESPECIE DESTINO
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    CATEGORÍA
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.modo_empleo &&
                                this.props.producto.modo_empleo.length > 0 ? (
                                  this.props.producto.modo_empleo.map(
                                    (me, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {me.dosis}
                                        </td>
                                        <td className="text-center">
                                          {me.especie}
                                        </td>
                                        <td className="text-center">
                                          {me.categoria || "N/A"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {["1", "2", "3", "5"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <>
                        <br />

                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="33.33%" className="text-center">
                                    TIPO ENVASE/EMPAQUE
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    PRESENTACIONES CANTIDAD
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    UNIDAD DE MEDIDA
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.envase &&
                                this.props.producto.envase.length > 0 ? (
                                  this.props.producto.envase.map((e, index) => (
                                    <tr key={index}>
                                      <td className="text-center">
                                        {e.envase}
                                      </td>
                                      <td className="text-center">
                                        {e.presentacion
                                          ? `${e.presentacion} ${e.cantidad}`
                                          : e.cantidad}
                                      </td>
                                      <td className="text-center">
                                        {e.unidad_medida}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {["1", "2", "5"].includes(
                      this.props.producto.tipo_producto_veterinario_id
                    ) ? (
                      <>
                        <br />
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th width="33.33%" className="text-center">
                                    PERIODO DE RETIRO/DESCARTE
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    UNIDAD DE TIEMPO
                                  </th>
                                  <th width="33.33%" className="text-center">
                                    ESPECIE
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.producto.descarte &&
                                this.props.producto.descarte.length > 0 ? (
                                  this.props.producto.descarte.map(
                                    (d, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {d.periodo}
                                        </td>
                                        <td className="text-center">
                                          {d.tiempo}
                                        </td>
                                        <td className="text-center">
                                          {d.especie}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      No se encontraron datos
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </fieldset>

                  <br />

                  <fieldset>
                    <legend>REGENTE</legend>
                    <div className="row">
                      <div className="col-lg-12">
                        <table className="table table-striped mb-0 table-hover">
                          <thead>
                            <tr>
                              <th className="text-center">NOMBRES</th>
                              <th className="text-center">APELLIDO PATERNO</th>
                              <th className="text-center">APELLIDO MATERNO</th>
                              <th className="text-center">GUID</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.producto.regentes &&
                            this.props.producto.regentes.length > 0 ? (
                              this.props.producto.regentes.map((r, index) => (
                                <tr key={index}>
                                  <td className="text-center">{r.nombres}</td>
                                  <td className="text-center">
                                    {r.apellido_paterno}
                                  </td>
                                  <td className="text-center">
                                    {r.apellido_materno}
                                  </td>
                                  <td className="text-center">{r.guid}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  No se encontraron datos
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </fieldset>

                  <br />

                  <fieldset>
                    <legend>DETALLES ADICIONALES</legend>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Grupo de riesgo:</label>
                          <div className="form-control">
                            {this.props.producto.grupo_ingrediente || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Clasificación del producto:</label>
                          <div className="form-control">
                            {this.props.producto.clase_producto || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Categoría de venta:</label>
                          <div className="form-control">
                            {this.props.producto.categorizacion_oficial ||
                              "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Tomo:</label>
                          <div className="form-control">
                            {this.props.producto.tomo || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Folio:</label>
                          <div className="form-control">
                            {this.props.producto.folio || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Número de registro:</label>
                          <div className="form-control">
                            {this.props.producto.no_registro || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Dossier:</label>
                          <div className="form-control">
                            {this.props.producto.dossier || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="btn-group  pull-right">
                        <button
                          className="btn btn-white "
                          onClick={this.props.handleModalCloseBtn}
                        >
                          Regresar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ProductClient;
